<!--
  Created 15.10.2023
  Simple StringLimiter component
  Wraps a string by length and adds a read more link if the string is too long, which expands when clicked
-->
<template>
  <span>
    <template v-if="limitedString.lengthError">
      {{ limitedString.stringFull }}
    </template>
    <template v-else>
      <template v-if="!showAll">
        {{ limitedString.stringLimited }}
      </template>
      <template v-else>
        {{ limitedString.stringFull }}
      </template>
      <StringLimiterLink
        :show-all="showAll"
        :is-simple="isSimple"
        @show-all="(v) => {(showAll = v);}" />
    </template>
  </span>
</template>

<script setup>
import {
  computed,
  ref,
} from 'vue';
import { stringLimit } from '@/utils';
import StringLimiterLink from '@/Components/StringLimiterLink.vue';

const props = defineProps({
  length: {
    type: Number,
    required: false,
    default: 350,
  },
  string: {
    type: String,
    required: true,
  },
  isSimple: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const showAll = ref(false);

const string = computed(() => props.string);
const length = computed(() => props.length);

const limitedString = computed(() => stringLimit(string.value, length.value, true));

</script>
